import React, { useEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ConfettiGenerator from 'confetti-js';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';

const ConfettiWrapper = styled.div`
    position: inherit;
`;

type ConfettiType = 'circle' | 'square' | 'triangle' | 'line';

interface ConfettiProps {
    max?: number;
    size?: number;
    animate?: boolean;
    props?: ConfettiType[];
    colors?: number[][];
    clock?: number;
    rotate?: boolean;
    start_from_edge?: boolean;
    respawn?: boolean;
    width?: string;
    height?: string;
}

const Confetti = ({
    max = 200,
    size = 1.5,
    animate = true,
    props = ['circle', 'square', 'triangle'],
    colors = [
        [165, 104, 246],
        [230, 61, 135],
        [0, 199, 228],
        [253, 214, 126],
    ],
    clock = 25,
    rotate = true,
    start_from_edge = true,
    respawn = true,
    width,
    height,
}: ConfettiProps) => {
    const id = uuid();

    useEffect(() => {
        const confetti = new ConfettiGenerator({
            target: id,
            max,
            size,
            animate,
            props,
            colors,
            clock,
            rotate,
            start_from_edge,
            respawn,
            width,
            height,
        });
        confetti.render();

        return () => confetti.clear();
    });

    return (
        <ConfettiWrapper>
            <canvas id={id} />
        </ConfettiWrapper>
    );
};

export default Confetti;
